export default "__VITE_ASSET__CN_rMK2P__"